import { render, staticRenderFns } from "./RequestRawTable.vue?vue&type=template&id=8c6aa2d4&scoped=true"
import script from "./RequestRawTable.vue?vue&type=script&lang=js"
export * from "./RequestRawTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6aa2d4",
  null
  
)

export default component.exports